module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.5489/img/callout-wave.svg"